import { render, staticRenderFns } from "./LinksTableModal.vue?vue&type=template&id=67d90d8e"
import script from "./LinksTableModal.vue?vue&type=script&lang=js"
export * from "./LinksTableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports